module.exports = "/_next/static/images/Macro-Nutrient-Profiled-def86946edb8bb64ebdf0b8763069074.png";